import { QUERY_KEYS } from '../../../../consts';
import { getAtomWithMutation } from '../../../../utils';
import { createHtmlSignDocumentService } from '../../../../services/documents/post';

export const createHtmlSignDocumentAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.DOCUMENTS.CREATE_HTML_SIGN_DOCUMENT,
  mutationFn: () => createHtmlSignDocumentService,
});
